import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";

const Usages = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [period, setPeriod] = useState(7);
  const user = useSelector((s) => s.user.user);
  return (
    <div className="flex flex-1 gap-4 flex-col relative p-6 py-4">
      <div className="flex flex-col md:flex-row w-full md:items-center justify-between">
        <h1 className="text-2xl font-semibold text-gray-600 my-3">Usages</h1>
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
          <div className="flex gap-3 flex-wrap">
            <DatePicker
              selected={startDate}
              onChange={(date) => {
                setStartDate(date);
                setPeriod(null);
              }}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              placeholderText="Start Date"
              className="border  px-3 py-2 rounded-md shadow-sm w-40"
            />
            <DatePicker
              selected={endDate}
              onChange={(date) => {
                setEndDate(date);
                setPeriod(null);
              }}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              placeholderText="End Date"
              className="border px-3 py-2 rounded-md shadow-sm w-40"
            />
            <select
              value={period || ""}
              onChange={(e) => {
                const val = Number(e.target.value);
                setPeriod(val);
                setStartDate(null);
                setEndDate(null);
              }}
              className="p-2 border rounded">
              <option value="">Select Period</option>
              <option value={7}>Last Week</option>
              <option value={30}>Last Month</option>
              <option value={90}>Last 3 Months</option>
              <option value={180}>Last 6 Months</option>
              <option value={365}>Last Year</option>
            </select>
          </div>
        </div>
      </div>

      <div className="flex gap-3 sm:gap-5 md:gap-10 flex-col md:flex-row"></div>
    </div>
  );
};
export default Usages;
